import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PlayerContextType {
  isFullscreenPlayerActive: boolean;
  setFullscreenPlayerActive: (active: boolean) => void;
}

const PlayerContext = createContext<PlayerContextType | undefined>(undefined);

export const PlayerProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isFullscreenPlayerActive, setIsFullscreenPlayerActive] = useState(false);

  const setFullscreenPlayerActive = (active: boolean) => {
    setIsFullscreenPlayerActive(active);
  };

  return (
    <PlayerContext.Provider value={{ isFullscreenPlayerActive, setFullscreenPlayerActive }}>
      {children}
    </PlayerContext.Provider>
  );
};

export const usePlayer = (): PlayerContextType => {
  const context = useContext(PlayerContext);
  if (context === undefined) {
    throw new Error('usePlayer must be used within a PlayerProvider');
  }
  return context;
};